// @module NetSuite.SuiteCommCPQ.Main
define('NetSuite.SuiteCommCPQ.Main.View', [
    'netsuite_suitecommcpq_main.tpl', 'Utils', 'Backbone', 'jQuery', 'underscore', 'NetSuite.SuiteCommCPQ.Main.Configuration',
    'NetSuite.SuiteCommCPQ.Main.Core', 'NetSuite.SuiteCommCPQ.Main.Debug'
], function(
    netsuite_suitecommcpq_main_tpl, Utils, Backbone, jQuery, _, Configuration, Core, Debugger
) {
    'use strict';
    var xView = {};
    // @class NetSuite.SuiteCommCPQ.Main.View @extends Backbone.View
    var Main_View = Backbone.View.extend({
        template: netsuite_suitecommcpq_main_tpl,
        initialize: function(options) {
            //
            Debugger.log('VCPQ','View : init');
            this.message = '';
            // var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Main.Service.ss'));
            if ((window.location.href.indexOf('shopping-local.ssp') != '-1')) {
                //Debugger.enable();
            }
            var pdp = options.container.getComponent('PDP'),
                plp = options.container.getComponent('PLP'),
                cart = options.container.getComponent('Cart'),
                userProfile = options.container.getComponent("UserProfile"),
                layout = options.container.getComponent('Layout'),
                configEnabled, allConfigurable, matrixSelRequired, addConfigurableGen, addConfigurableLinked,
                hideConfigBtn, hideEditCfgBtn, onlyConfigurable, showQuantity;
            Core.setGlobal('applyItemView', applyItemView);
            xView.pdp = pdp;
            xView.cart = cart;
            xView.user = userProfile;
            Core.init(cart, pdp, userProfile);
            configEnabled = Configuration.get('isConfigEnabled');
            hideConfigBtn = Configuration.get('hideConfigBtn');
            hideEditCfgBtn = Configuration.get('hideEditCfgBtn');
            allConfigurable = Configuration.get('allConfigurable');
            onlyConfigurable = Configuration.get('onlyConfigurable');
            matrixSelRequired = Configuration.get('matrixSelRequired');
            addConfigurableGen = Configuration.get('addConfigurableGen');
            addConfigurableLinked = Configuration.get('addConfigurableLinked');
            showQuantity = Configuration.get('showQuantity');
            xView.configEnabled = configEnabled;
            xView.hideConfigBtn = hideConfigBtn;
            xView.hideEditCfgBtn = hideEditCfgBtn;
            xView.allConfigurable = allConfigurable;
            xView.onlyConfigurable = onlyConfigurable;
            xView.matrixSelRequired = matrixSelRequired;
            xView.addConfigurableGen = addConfigurableGen;
            xView.addConfigurableLinked = addConfigurableLinked;
            xView.showQuantity = showQuantity;
            if (cart) {
                cart.on('afterShowContent', function (event) {
                    //
                    Debugger.log('VCPQ','View : Cart afterShowContent');
                });
            }
            if (pdp) {
                pdp.on('afterShowContent', function (event) {
                    //
                    Debugger.log('VCPQ','View : PDP afterShowContent');
                    applyItemView();
                });
            }
            if (plp) {
                plp.on('afterShowContent', function () {
                    Debugger.log('VCPQ','View : PLP afterShowContent');
                });
            }
            addCpqListener();
            hidePricesForConfigurableItems();
            //
            function applyItemView() {
                //
                var itemInfo = pdp.getItemInfo(), visOptions = {};
                Debugger.log('VCPQ Item info '+(configEnabled ? 'CFG-ON' : 'CFG-OFF'), itemInfo);
                xView.itemInfo = itemInfo;
                if (isConfigurable(itemInfo.item.custitem_scpq_item_product_id, itemInfo.item.custitem_scpq_item_isconf)) {
                    visOptions.isConfigurable = true;
                    Debugger.log('VCPQ Item info', 'isConfigurable');
                    var u = window.location.href;
                    if (!hideEditCfgBtn)
                        visOptions.showEditButton = true;
                    if (!hideConfigBtn)
                        visOptions.showCfgButton = true;
                    if (showQuantity)
                        visOptions.showQuantity = true;
                    if (u.endsWith('/cart') || u.endsWith('#cart') || u.indexOf('/cart?') !== -1 || u.indexOf('#cart?') !== -1) {
                        // shopping cart
                        visOptions.mode = 'edit';
                    } else {
                        // item tile
                        visOptions.mode = 'run';
                        if (isAllowedToAddToCart(itemInfo.item.custitem_scpq_item_product_id, itemInfo.item.custitem_scpq_item_isconf)) {
                            visOptions.allowAdd = true;
                        }
                    }
                } else {
                    visOptions.allowAdd = true;
                }
                setTimeout(function(){
                    visualTile(visOptions);
                }, 0);
            }
            function hidePricesForConfigurableItems() {
                var variablesToUnset = [
                    { view: 'ProductViews.Price.View', variable: 'isPriceRange', type: 'boolean' },
                    { view: 'ProductViews.Price.View', variable: 'priceFormatted', type: 'string' },
                    { view: 'ProductViews.Price.View', variable: 'frequency', type: 'string' },
                    { view: 'ProductViews.Price.View', variable: 'showComparePrice', type: 'boolean' },
                    { view: 'Transaction.Line.Views.Price.View', variable: 'rateFormatted', type: 'string', hiddenIfHasConfig: true },
                    { view: 'Transaction.Line.Views.Price.View', variable: 'showComparePrice', type: 'boolean', hiddenIfHasConfig: true },
                    { view: 'Header.MiniCartItemCell.View', variable: 'showComparePrice', type: 'boolean', hiddenIfHasConfig: true },
                    { view: 'Transaction.Line.Views.Cell.Navigable.View', variable: 'showBlockDetail2', type: 'boolean', hiddenIfHasConfig: true }, // unit price block
                    { view: 'Transaction.Line.Views.Cell.Selectable.View', variable: 'detail2Title', type: 'string', hiddenIfHasConfig: true }, // unit price title
                    { view: 'Transaction.Line.Views.Cell.Selectable.View', variable: 'detail2', type: 'string', hiddenIfHasConfig: true }, // unit price value
                ];
                variablesToUnset.forEach(function(item) {
                    try {
                        layout.addToViewContextDefinition(item.view, item.variable, item.type, function(context) {
                            if (isPriceHidden(context, item.hiddenIfHasConfig)) {
                                return item.type === 'boolean' ? false : '';
                            }
                            return context[item.variable];
                        });
                    } catch (e) {
                        Debugger.log(e.message);
                    }
                });
                function isPriceHidden(context, hiddenIfHasConfig) {
                    var item, options;
                    if (context.model) {
                        item = context.model.item || context.model;
                        options = context.model.options;
                    } else if (context.line) {
                        item = context.line.item;
                        options = context.line.options;
                    }
                    if (hiddenIfHasConfig) {
                        return hasConfig(options);
                    }
                    return isConfigurable(item.custitem_scpq_item_product_id, item.custitem_scpq_item_isconf)
                        && !isAllowedToAddToCart(item.custitem_scpq_item_product_id, item.custitem_scpq_item_isconf);
                }
            }
            function hasConfig(options) {
                return configEnabled && !!getOptionConfig({options: options});
            }
            function isConfigurable(custitem_scpq_item_product_id, custitem_scpq_item_isconf) {
                return configEnabled &&
                    (
                        custitem_scpq_item_product_id // cpq product ID assigned
                        || (allConfigurable && (!onlyConfigurable || custitem_scpq_item_isconf)) // all configurable or this one is configurable
                    )
            }
            function isAllowedToAddToCart(custitem_scpq_item_product_id, custitem_scpq_item_isconf) {
                return (addConfigurableGen && (allConfigurable && (!onlyConfigurable || custitem_scpq_item_isconf))) ||
                    (addConfigurableLinked && custitem_scpq_item_product_id);
            }
        },
        events: {
            'click [data-type="config-run"]' : 'config_run',
            'click [data-type="config-edit"]' : 'config_edit'
        },
        bindings: {},
        childViews: {
        },
        loaded: function loaded() {
            this.isLoading = false;
            this.render();
            Core.setUrl(this.model.getUrl());
            Core.fireEvent('ready');
        },
        //@method getContext @return NetSuite.SuiteCommCPQ.Main.View.Context
        getContext: function getContext() {
            //@class NetSuite.SuiteCommCPQ.Main.View.Context
            var isLoading = !!this.isLoading,
                model = this.model,
                context = {
                    isLoading: !!this.isLoading
                };
            if (!isLoading) {
                _(context).extend({
                    title: model.getTitle()
                });
            }
            return context;
        },
        config_run: function () {
            cpqOpenConfig();
        },
        config_edit: function () {
            cpqOpenConfig({edit: true});
        },
        _init: function() {
            Debugger.setGlobal('main_view', this);
            Debugger.setGlobal('xView', xView);
            Core.setGlobal('openConfig', cpqOpenConfig);
            Core.setGlobal('closeConfig', cpqCloseConfig);
            Core.setGlobal('postMessage', cpqPostMessage);
            Core.setGlobal('addMessageListener', cpqAddMessageListener);
        }
    });
    return Main_View;
    //
    function visualTile(options) {
        //
        if (!options) {
            Debugger.log('> visualTile :: none');
            return ;
        }
        Debugger.log('> visualTile ::','isConfigurable='+options.isConfigurable+', showCfgButton='+options.showCfgButton+
            ', showEditButton='+options.showEditButton+', allowAdd='+options.allowAdd + ', mode='+options.mode + ' ');
        var tStyle = '';
        //
        if (options.allowAdd) {
            tStyle += 'div .product-details-full-actions,'+
                'div.product-details-quickview-main div.product-views-price,'+
                'div.product-details-full-main div.product-views-price,'+
                ' div .product-details-quantity-options, div .product-details-quickview-actions { display: block; } ';
        } else if (options.showQuantity)
            tStyle += 'div .product-details-quantity-options { display: block; } ';
        if (options.isConfigurable) {
            tStyle += 'div .v-cfg-container { display: block; } ';
        }
        switch (options.mode) {
            case 'run':
                tStyle += 'div .v-runcfg-container { display: block; } ';
                tStyle += 'div .v-editcfg-container { display: none; } ';
                break;
            case 'edit':
                tStyle += 'div .v-editcfg-container { display: block; } ';
                tStyle += 'div .v-runcfg-container { display: none; } ';
                break;
        }
        if (options.showCfgButton) {
            tStyle += 'div .configure-button.vcpq-native { display: block; } ';
        }
        if (options.showEditButton) {
            tStyle += 'div .edit-config-button.vcpq-native { display: block; } ';
        }
        jQuery('#v-cfg-style-over').text(tStyle);
        jQuery('#in-modal-v-cfg-style-over').text(tStyle);
    }
    //
    function cpqOpenConfig(options) {
        var sysOptions = ['productid','intid','configid','mchilds','edit'];
        options = options || {};
        Debugger.log('VCPQ','View : cpqOpenConfig');
        var productId, intId, configId = null, matrix, mChilds = '', isMatrix, itemInfoSet = false, quantity = 1;
        //
        if (xView.itemInfo && xView.itemInfo.item) {
            itemInfoSet = true;
            var ii = xView.pdp.getItemInfo();
            if (ii && ii.quantity)
                quantity = ii.quantity;
        }
        // set product ID (mandatory)
        if (options.productid) {
            productId = options.productid;
        } else {
            if (itemInfoSet) {
                productId = xView.itemInfo.item.custitem_scpq_item_product_id;
            }
            if (!productId) {
                productId = getOptionConfig(xView.itemInfo, 'productId');
            }
            if (!productId) {
                productId = xView.allConfigurable; // = 1
            }
            //productId = xView.itemInfo.item.custitem_scpq_item_product_id || getOptionConfig(xView.itemInfo, 'productId') || xView.allConfigurable; // = 1
        }
        if (!productId) {
            Debugger.error('Config Product is not specified');
            return ;
        }
        // set item internal ID (optional)
        if (options.intid) {
            intId = options.intid;
        } else if (!options.productid && itemInfoSet) {
            // get from PDP only when options.productid is not set
            intId = xView.itemInfo.item.internalid;
        }
        // matrix subitems (only when launch from PDP)
        if (!options.productid) {
            matrix = xView.pdp.getSelectedMatrixChilds();
            isMatrix = !!(matrix && matrix.length);
            if (matrix && matrix.length == 1) {
                mChilds += matrix[0].internalid;
            }
        }
        //
        Debugger.log('VCPQ', 'View : Open config ID = ' + productId);
        if (options.configid) {
            configId = options.configid;
        } else if (options.edit) {
            configId = getOptionConfig(xView.itemInfo);
        }
        if (!isMatrix || (mChilds || !xView.matrixSelRequired)) {
            var launchData = {
                productid: productId,
                intid: intId,
                configid: configId,
                mchilds: mChilds
            };
            if (xView.showQuantity) {
                launchData.qty = quantity;
            }
            for (var key in options) {
                if (sysOptions.indexOf(key) === -1) {
                    launchData[key] = options[key];
                }
            }
            Core.launchConfig(launchData, options.hidden === true);
        } else {
            alert('Please select item options');
        }
    }
    //
    function cpqCloseConfig() {
        Core.closeConfig();
    }
    //
    function cpqPostMessage(type, data) {
        Core.postMessage(type, data);
    }
    //
    function cpqAddMessageListener(type, func) {
        Core.addMessageListener(type, func);
    }
    //
    function addCpqListener() {
        //
        Debugger.log('VCPQ','View : addCpqListener');
        if (!xView.listenerSet) {
            xView.listenerSet = true;
            window.addEventListener('message', Core.processEventData);
            Debugger.log('VCPQ','View : Event listener set');
        }
    }
    //
    function getOptionConfig(item, optionName) {
        //
        Debugger.log('VCPQ','View : getOptionConfig');
        if (!item)
            return null;
        var configData, parsedData;
        optionName = optionName || 'configId';
        if (item.options) {
            for (var i = 0; i < item.options.length; i++) {
                var opt = item.options[i];
                if (opt.cartOptionId === 'custcol_scpq_item_opt_config_data' || opt.cartOptionId === 'custcol_scpq_item_col_config_data') {
                    configData = opt.value ? opt.value.internalid : null;
                    Debugger.log('VCPQ','View : configData: '+configData);
                    if (configData) {
                        if (!isNaN(configData) && optionName == 'configId') {
                            return configData; // configuration ID
                        } else {
                            try {
                                parsedData = JSON.parse(configData);
                                return parsedData[optionName];
                            } catch(e) {
                                //
                            }
                        }
                    }
                }
            }
        }
        return '';
    }
    //
    function existTimeout(func, selector) {
        //
        var timeouts = [0, 1, 5, 10],//, 25, 50, 100, 200, 500],
            timeIndex = -1;
        //
        function tryRun() {
            var sel, delay, currentDelay;
            sel = jQuery(selector);
            if (sel && sel.length) {
                currentDelay = timeIndex === -1 ? '*' : timeouts[timeIndex];
                Debugger.log('VCPQ','View EX-T : finish render tile : ' + currentDelay);
                func();
            }// else {
            timeIndex++;
            delay = timeouts[timeIndex];
            if (delay !== undefined) {
                setTimeout(function () {
                    tryRun();
                }, delay);
            }
            //}
        }
        //
        tryRun();
    }
});
